/**
 *  @class
 *  @function RecentlyViewedProducts
 */
/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = Number(this.dataset.max);
      const recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds) {
        window.recentlyViewedIds = JSON.parse(recentIds);
      }
    }

    connectedCallback() {
      this.fetchProducts();
    }

    // Shopify's native /search endpoint has no supported "handle:" query field - a query built
    // that way always returns zero results. Fetching each handle's own product page (with an
    // alternate template that renders just the card markup) is an exact, guaranteed lookup instead.
    fetchProducts() {
      // window.recentlyViewedIds defaults to [] in app.js, but script execution order between
      // deferred scripts follows document order - don't assume app.js has run first.
      const recentlyViewedIds = Array.isArray(window.recentlyViewedIds) ? window.recentlyViewedIds : [];
      const productHandles = recentlyViewedIds.filter(val => val !== this.currentId).slice(0, this.max);
      if (!productHandles.length) return;

      Promise.all(
        productHandles.map(handle =>
          fetch(`${theme.routes.root_url}/products/${handle}?view=card-fragment`.replace('//', '/'))
            .then(response => (response.ok ? response.text() : ''))
            .then(text => {
              const card = new DOMParser().parseFromString(text, 'text/html').querySelector('#ProductCardFragment');
              return card ? card.innerHTML : '';
            })
            .catch(() => '')
        )
      ).then(fragments => {
        const html = fragments.join('').trim();
        if (!html.length) return;
        this.container.innerHTML = html;
        this.classList.add('recently-viewed-products--loaded');
        this.container.querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
